import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { ApiError, bindQueryClient } from './api'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,        // 1 min por defecto
      refetchOnWindowFocus: false,
      // No reintentar errores 4xx (401/403/400 son terminales);
      // 5xx sí (probable blip transitorio).
      retry: (count, err) => {
        const status = (err as ApiError | undefined)?.status
        if (status && status >= 400 && status < 500) return false
        return count < 1
      },
    },
  },
})

// Permite que el http() de api.ts invalide queries ['me'] en 401.
bindQueryClient(queryClient)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
)
